import {
    getSchedulerMetadata
} from "api/onboarding/scheduler/onboardingScheduler";

window.Scheduler = {
    loadPrefs: function() {
        getSchedulerMetadata().then(res => {
            if (res.isConfigured) {
                MyWindow.close();
                window.sellsyapp.$store.state.popupPanel.popupSchedulerSettings.display = true
                window.sellsyapp.$store.state.popupPanel.popupSchedulerSettings.props = { defaultEmail: res?.email.email }
            } else {
                window.sellsyapp.$router.replace('/onboarding/scheduler')
            }
        })
    }
}